<script setup lang="ts">
defineProps<{
  label: string;
}>();

const emit = defineEmits<{
  prev: [];
  next: [];
}>();
</script>

<template>
  <div :class="$style.group">
    <button :class="$style.btn" @click="emit('prev')">
      <Icon name="ic:baseline-chevron-left" size="20" />
    </button>
    <span :class="$style.label">{{ label }}</span>
    <button :class="$style.btn" @click="emit('next')">
      <Icon name="ic:baseline-chevron-right" size="20" />
    </button>
  </div>
</template>

<style module lang="scss">
.group {
  display: flex;
  align-items: center;
  gap: 4px;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: var(--color-white);
  cursor: pointer;
  padding: 2px;
  border-radius: 4px;

  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }
}

.label {
  color: var(--color-white);
  font-family: var(--font-golos);
  font-weight: 500;
  font-size: 14px;
  line-height: 1.4;
  user-select: none;
  min-width: 70px;
  text-align: center;
}
</style>
